import { ButtonBase, Stack, styled, Typography } from '@mui/material'
import { ArrowIOSIcon } from '$common/icons/arrow-ios'
import { t } from '$i18n'

const Root = styled(ButtonBase)`
  height: 108px;
  width: 100%;
  padding: 28px 20px 28px 30px;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
`

const StyledStack = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: '12px',
  left: '12px',
  color: theme.palette.white,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

const StyledIcon = styled(ArrowIOSIcon)`
  margin-right: 4px;
`

const TitleBox = styled(Stack)`
  margin-right: 10px;
  align-items: start;
  overflow: hidden;
`

interface Props {
  title: string
  description: string
  icon: JSX.Element
  rootSx: Record<string, unknown>
  onClick: () => unknown
}
export function ContentBox({
  title,
  icon,
  rootSx,
  description,
  onClick,
}: Props) {
  return (
    <Root sx={{ ...rootSx }} onClick={onClick}>
      <StyledStack direction="row">
        <Typography variant="caption1" color="white">
          {t('navigationBarToolBox.watch')}
        </Typography>
        <StyledIcon sx={{ height: '20px', width: '20px', color: 'white' }} />
      </StyledStack>
      <Stack direction="row" sx={{ height: '100%', width: '100%' }}>
        {icon}
        <TitleBox justifyContent="space-between">
          <Typography
            variant="subtitle1"
            sx={{ lineHeight: '22px', marginTop: '1px' }}
            color="white"
            dir="auto"
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="white"
            sx={{ lineHeight: '20px', marginBottom: '1px', width: '100%' }}
            noWrap
          >
            {description}
          </Typography>
        </TitleBox>
      </Stack>
    </Root>
  )
}
